import { actionDuckUtils } from 'wanderu-ducks-utils';

import sliceNamespace from '../../types';
import { serializeLiveCheckCachedTripParams as serializeParams } from '../utils';

const namespace = 'LIVE_CHECK_CACHED_TRIP';
const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace, serializeParams);

export {
    actions,
    namespace,
    reducer,
    selectors,
};
